<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.billing && source">

    <div class="banner center" style="max-width:1000px; margin-top: 5px;">
        <div class="row row_header freeze_height">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-2">
                        <button [id]="elementIds.settings" class="button_icon button_icon_color"
                            (click)="isOpenPopupConfig = true;" style="top: 2px;right: 2px;">
                            settings_suggest
                        </button>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-9">{{localService.languageContent.billing.name}}</div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row text-end">
                    <div class="col-4">{{localService.languageContent.billing.price}}</div>
                    <div class="col-4">{{localService.languageContent.billing.qty}}</div>
                    <div class="col-4">Total</div>
                </div>
            </div>
        </div>

        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row" *ngFor="let item of source.items; let idx = index">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-2 wrap-div">{{ idx + 1 }}</div>
                        <div class="col-1 wrap-div text-center">
                            <button class="button_icon text-danger" (click)="onDelete(item.key)"
                                style="top: 2px; right: 2px;">
                                delete
                            </button>
                        </div>
                        <div class="col-9 wrap-div">{{ item.v1 }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row text-end">
                        <div class="col-4 wrap-div">{{ item.v2 | number:'1.2-2' }}</div>
                        <div class="col-4 wrap-div">{{ item.v3 | number:'1.2-2'}}</div>
                        <div class="col-4 wrap-div font-weight-bold">{{ getItemTotal(item) | number:'1.2-2' }}</div>
                    </div>
                </div>
            </div>
            <div class="row styled_row" *ngIf="source.items.length === 0">
                <div class="col-12 text-center text-muted py-3">
                    No items added to the list
                </div>
            </div>
        </div>
    </div>

    <div class="footer freeze_height" *ngIf="data">
        <div class="row">
            <div class="col-md-6 d-flex align-items-center gap-2">
                <button [id]="elementIds.new_bill" [disabled]="billingId == '0'" class="button_icon button_icon_color"
                    (click)="onAddNewBill()" title="{{localService.languageContent.billing.add_bill}}"
                    style="max-width: 40px; min-width: 40px; padding: 0;top: 2px;right: 2px;">
                    post_add
                </button>

                <div class="position-relative flex-grow-1">
                    <input type="text" [id]="elementIds.name"
                        placeholder="{{localService.languageContent.billing.name}}" [(ngModel)]="data.v2"
                        (input)="onGetSuggestion()" (keydown)="onNameKeydown($event)" autocomplete="off"
                        style="width: 100%;" />

                    <div class="suggestion-list" *ngIf="suggestions && suggestions.length > 0">
                        <div class="suggestion-item" *ngFor="let item of suggestions; let idx = index"
                            [class.active]="selectedSuggestionIndex === idx" (click)="onSelectSuggestion(item)">
                            <span class="suggestion-title">{{ item.v2 }}</span>
                            <span class="suggestion-amount float-end text-muted">{{ item.v3 | number:'1.2-2'}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-3">
                        <input type="number" [id]="elementIds.price"
                            placeholder="{{localService.languageContent.billing.price}}" [(ngModel)]="data.v3"
                            (keydown.enter)="localService.onFocusNextInput(elementIds.qty,focusInputType.TextBox)" />
                    </div>
                    <div class="col-3">
                        <input type="number" [id]="elementIds.qty"
                            placeholder="{{localService.languageContent.billing.qty}}" [(ngModel)]="data.v4"
                            (keydown.enter)="onAdd()" />
                    </div>
                    <div class="col-1">
                        <button [id]="elementIds.add" class="button_icon button_icon_color" (click)="onAdd()"
                            style="top: 2px;right: 2px;" title="{{localService.languageContent.common.add}}">
                            add_circle_outline
                        </button>
                    </div>
                    <div class="col-5 d-flex align-items-center gap-2">
                        <div class="en price flex-grow-1" style="width: 100%;">{{ total | number:'1.2-2' }}</div>

                        <button [id]="elementIds.print" [disabled]="billingId == '0' || source.items.length == 0"
                            class="button_icon button_icon_color" (click)="onPrint()" style="top: 2px;right: 2px;"
                            title="{{localService.languageContent.billing.print}}">
                            print
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="businessId.length > 5">
    <app-print *ngIf="isPrintReceipt && billingId.length > 5" [fileName]="billingId" [content]="printContent"
        (onPrinted)="onPrintedReceipt()" />
    <app-no-config-bill-settings [businessId]="businessId" [(isOpenPopup)]="isOpenPopupConfig"
        (onClose)="onSettingsClosed($event)" />
</div>